import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css']
})
export class AddCategoryComponent {

  @Output() eventCancel = new EventEmitter();
  @Output() eventSave = new EventEmitter();

  @Input() element;
  @Input() encabezado;

  formCategoria = new FormGroup({
      nombre: new FormControl(''),
      descripcion: new FormControl(''),    
  });

  valoresDefault1 = {
    nombre: '',
    descripcion: '',
  }

  constructor(){
  }

  ngOnInit(){
    if(this.element){
      this.formCategoria.controls['nombre'].setValue(this.element.name);
      this.formCategoria.controls['descripcion'].setValue(this.element.description);
    }
  }

  public puedeGuardar(){
    const v1 = this.formCategoria.controls['nombre'].value;
    const v2 = this.formCategoria.controls['descripcion'].value;
    if(v1 === '' || v2 === ''){
      return 'w3-disabled'
    }
    return '';
  }

  public guardarInfo(){
    const v1 = this.formCategoria.controls['nombre'].value;
    const v2 = this.formCategoria.controls['descripcion'].value;
    this.eventSave.emit([v1,v2])
  }

  public cancel(){
    this.eventCancel.emit();
  }

}
